var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditUbicazionePadre',{attrs:{"id":_vm.id,"idMagazzino":_vm.idMagazzino}})
}
var staticRenderFns = []

export { render, staticRenderFns }